/** Hash route for data analysis (e.g. `/#/data-analysis` on GitHub Pages). */
export const DATA_ANALYSIS_ROUTE = '/data-analysis';
